import Button from '../../atoms/button';
import { Text } from '../../typography/text/Text';
import styles from './DeliveryDetails.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { textForDelivery } from './options';
import { useCartContext } from '../../../provider/cart/CartContext';
import { convertTextToId } from '../../../utils/convertTextToId';

export interface Store {
  id: string;
  channel?: {
    id: string;
  };
  quantity: number;
  storeName: string;
}

export interface ShippingMethod {
  name: string;
  description?: string;
  rates?: {
    projectSpecificData?: {
      freeAbove?: number;
    };
  }[];
}

export interface DeliveryDetailsProps {
  shippingText?: string;
  className?: string;
  handleOpenStoreLocator: () => void;
  selectedStore?: {
    channel?: {
      id: string;
    };
  };
  storeList?: Store[];
  currentSiteRegion?: string;
  shouldHideClickCollect?: boolean;
}

const DeliveryDetails: React.FC<DeliveryDetailsProps> = ({
  shippingText = '',
  className,
  handleOpenStoreLocator,
  selectedStore,
  storeList,
  currentSiteRegion,
  shouldHideClickCollect,
}) => {
  const store = storeList?.find((item) => item.id === selectedStore?.channel?.id);
  const stockQty =
    store?.quantity > 2 ? 'In stock' : store?.quantity <= 2 && store?.quantity > 0 ? 'Low in stock' : 'Out of stock';
  const buttonText = store?.storeName ? 'Change store' : 'Find in Store';

  const { dispatchDays, dispatchPrice } = textForDelivery;
  const { cartData } = useCartContext();

  const cartShippingMethod = cartData?.availableShippingMethods as ShippingMethod[];
  const shippingMethod =
    cartShippingMethod &&
    cartShippingMethod.length &&
    cartShippingMethod.find((el) => {
      return currentSiteRegion === 'NZ' ? el?.name === 'NZ Standard' : el?.name === 'Australia Post - Standard';
    });

  const shippingInfo = [shippingMethod?.description, shippingMethod?.rates?.[0]?.projectSpecificData?.freeAbove];

  return (
    <div className={clsx(styles.wrapper, className)}>
      <div className={styles.block}>
        <Text className={`${styles.text} ${styles.boldJag}`}>
          {shouldHideClickCollect ? 'View store stock availability' : `Click ${'&'} Collect`}
        </Text>
        {/*@ts-ignore*/}
        <Button
          variant="primary"
          as="text"
          className={styles.link}
          onClick={handleOpenStoreLocator}
          data-open-find-store={convertTextToId(buttonText)}
        >
          {buttonText}
        </Button>
      </div>

      {!shouldHideClickCollect && store?.storeName && (
        <div className={`${styles.block} ${styles.storeInfo}`}>
          <Text className={styles.rightOffset}>{store.storeName}</Text>
          {store?.quantity <= 0 ? (
            <Text className={styles.text}>
              <span className={styles.statusBlockOutOfStock} />
              Not Available - {stockQty}
            </Text>
          ) : (
            <Text className={styles.text}>
              <span className={styles.statusBlock} />
              Available - {stockQty}
            </Text>
          )}
        </div>
      )}

      <div className={styles.block}>
        <Text className={`${styles.text} ${styles.boldJag}`}>Shipping: {shippingText}</Text>
        <Text className={styles.shippingInfo}>
          {shippingInfo[1] || shippingInfo[1] === 0 ? (
            <span>Free delivery over ${Number(shippingInfo[1]) / 100}</span>
          ) : (
            <span>Free delivery over ${dispatchPrice}</span>
          )}
          {shippingInfo[0] ? (
            <span className={styles.dispatch}>{shippingInfo[0]}</span>
          ) : (
            <span className={styles.dispatch}>Dispatch in {dispatchDays} business days</span>
          )}
        </Text>
      </div>
    </div>
  );
};

export default DeliveryDetails;

DeliveryDetails.propTypes = {
  shippingText: PropTypes.string,
};
